export class RequestPerformanceRecordDto {
  periodId: string;
  endDate: string;
}

export class RequestPerformanceSearchDto {
  search: string;
}

export class RequestPerformanceRecordEmailDto {
  periodId: string;
  endDate: string;
  email: string;
  fullName: string;
}

export class ResponseReportSendEmailDto {
  message: string;
  data?: any;
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/performance-report.dto.ts